import GeneralProduct from '~/Api/Product/Product';

import { ReferencePrice } from './ReferencePrice';

export class Product {
	constructor(
		public readonly product: GeneralProduct,
		public readonly referencePrices: ReferencePrice[],
		public readonly fxComparisonReferencePrice: ReferencePrice | null,
		public readonly packageSizeForCalculation: number | null,
		public readonly packageSizeForSingleUnit: number | null,
		public readonly singleUnitPackageSize: boolean,
		public readonly selected: boolean,
		public readonly selectable: boolean,
		public readonly referenceDataSource: boolean,
		public readonly fxComparisonResolution: string
	) {}
}
